import { useEffect, useState } from 'react'
import s from './Offices.scss'
import Select from 'react-select'
import { makeGetRequest } from 'utils/api'
import { toTeams } from 'utils/serializers'

const Offices = ({ className, teamsCb, dealTeams }) => {
  const [teams, setTeams] = useState([])

  useEffect(() => {
    ;(async () => {
      const teams = await makeGetRequest('/v1/teams')
      setTeams(teams)
    })()
  }, [])

  return (
    <div className={className}>
      <div className={s.dealAwarded}>
        <span className={s.officeLabel}>Teams:</span>
        <Select
          value={dealTeams}
          options={toTeams(teams)}
          onChange={value => teamsCb(value)}
          isMulti
        />
      </div>
    </div>
  )
}

export default Offices
